import BASEAPI from '@/api/dataBase.js';
import { isNumberValidator } from '@/validators';
export const baseForm = (ctx) => {
  return [
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      maxlength: 100,
    },
    {
      prop: 'companyCode',
      name: '公司',
      type: 'select',
      label: 'personCompanyName',
      value: 'personCompanyCode',
      options: ctx.companyList || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractType',
      name: '合同类别',
      type: 'ajaxSelect',
      apiUrl: BASEAPI.DIC_CREDIT_API,
      apiData: { dictType: 'serviceContractType' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
        departmentCode: ctx.baseFormData.departmentCode, //部门
        companyCode: ctx.baseFormData.companyCode, //公司
      },
      currentValue: ctx.baseFormData.supplierName ? ctx.baseFormData.supplierName : null,
      checkRowKeys: [ctx.baseFormData.supplierNo ? ctx.baseFormData.supplierNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
    },

    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseFormData?.projectInitiationNo
        ? ctx.baseFormData?.projectInitiationNo
        : null,
      checkRowKeys: [
        ctx.baseFormData.projectInitiationNo ? ctx.baseFormData.projectInitiationNo : null,
      ],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.baseFormData.companyCode,
        platformtCompanyName: ctx.baseFormData.companyName,
        applyCompanyNo: ctx.baseFormData.companyCode,
        applyCompanyName: ctx.baseFormData.companyName,
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      disabled: true,
      placeholder: '请输入项目名称',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司',
      type: 'select',
      options: ctx.platformCompanyFileList,
      disabled: !ctx.baseFormData.projectInitiationNo,
      placeholder: '请选择平台公司',
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司档案编号',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      placeholder: '请输入外部合同号',
    },
    {
      prop: 'purchaseQuantity',
      name: '采购数量',
      type: 'inputNumber',
      precision: 8,
      disabled: true,
      placeholder: '自动填充',
    },
    {
      prop: 'contractTotalAmount',
      name: '合同总金额',
      type: 'inputNumber',
      precision: 6,
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
      format: 'yyyy-MM-dd',
    },
    {
      prop: 'contractValidStart',
      name: '合同生效日期',
      type: 'startDaterangePicker',
      format: 'yyyy-MM-dd',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractValidEnd',
      name: '合同到期日期',
      type: 'endDaterangePicker',
      format: 'yyyy-MM-dd',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'isNotEndDate',
      name: '至合同履行截止日止',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      type: 'checkbox',
    },
    {
      prop: 'isDefault',
      name: '有无违约责任标识',
      labelPosition: 'right',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      changeMethod: 'changeMethod',
    },

    {
      prop: 'departmentCode',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractSalesmanNo',
      name: '部门负责人',
      placeholder: '请选择部门负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: 'changeMethod',
      currentValue: ctx.baseFormData?.contractSalesmanName,
    },

    {
      prop: 'contractCreateDate',
      name: '制单日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: true,
    },
    ctx.$route.query.isCopy == 'true'
      ? {
          prop: 'contractOperaterName',
          name: '经办人',
          placeholder: '请选择经办人',
          type: 'searchTableSpec',
          searchType: 'personnel',
          isMultiple: true,
          extraData: {
            personCompanyCode: ctx.userInfo.companyCode,
          },
          currentValue: ctx.baseFormData?.contractOperaterName,
          changeMethod: 'changeMethod',
        }
      : {
          prop: 'contractOperaterName',
          name: '经办人',
          type: 'input',
          disabled: true,
        },

    // {
    //   prop: 'replyInvoiceDate',
    //   name: '回票日期',
    //   type: 'date',
    // },
    {
      type: 'dict',
      dictType: 'liquidatedDamages',
      name: '合同违约金类型',
      prop: 'liquidatedDamagesType',
      disabled: ctx.disabledFieldList.includes('liquidatedDamagesType'),
      changeMethod: 'changeMethod',
      placeholder: '请选择',
    },
    {
      prop: 'liquidatedFixedValue',
      name: '违约金固定值',
      type: 'input',
      placeholder: '请输入违约金固定值',
      disabled: ctx.disabledFieldList.includes('liquidatedFixedValue'),
    },
    {
      prop: 'liquidatedInterestRate',
      name: '违约金日利率',
      type: 'inputNumber',
      placeholder: '请输入违约金日利率',
      append: '%',
      disabled: ctx.disabledFieldList.includes('liquidatedInterestRate'),
    },
    {
      prop: 'isPrepay',
      name: '预付',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      labelPosition: 'right',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'creditAmount',
      name: '预付金额',
      type: 'inputNumber',
      placeholder: '请输入预付金额',
      disabled: ctx.baseFormData.isPrepay == '0' || !ctx.baseFormData.isPrepay,
    },
    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'checkbox',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      disabled: true,
    },
    {
      prop: 'pricingRule',
      name: '定价模式',
      type: 'ajaxSelect',
      clearable: true,
      apiUrl: BASEAPI.DIC_CREDIT_API,
      apiData: { dictType: 'pricing_rule' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'marginAmount',
      name: '保证金',
      type: 'input',
    },
    {
      prop: 'businessType',
      name: '业务性质',
      type: 'ajaxSelect',
      clearable: false,
      apiUrl: BASEAPI.DIC_CREDIT_API,
      apiData: { dictType: 'purchase_business_type' },
      placeholder: '请选择业务性质',
    },
    {
      prop: 'receiptMethod',
      name: '付款方式',
      type: 'select',
      options: ctx.dictListMap?.apply_payment_method || [],
      changeMethod: 'changeMethod',
    },
    {
      name: '货币',
      prop: 'companyCurrency',
      type: 'select',
      options: ctx.currencyList,
      changeMethod: 'changeMethod',
    },

    {
      prop: 'overShippedPercentage',
      name: '溢装比例',
      type: 'inputNumber',
      append: '%',
    },

    {
      prop: 'shortShippedPercentage',
      name: '短装比例',
      type: 'inputNumber',
      append: '%',
    },
    {
      prop: 'lastestReceiveProductDay',
      name: '最晚收货日',
      type: 'date',
      format: 'yyyy-MM-dd',
      placeholder: '请选择最晚收货日',
    },
    {
      prop: 'lastestPayMoneyDay',
      name: '最晚付款日',
      type: 'date',
      format: 'yyyy-MM-dd',
      placeholder: '请选择最晚付款日',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000;
        },
      },
    },
    {
      prop: 'incomeMethod',
      name: '收益方式',
      apiUrl: BASEAPI.DIC_CREDIT_API,
      apiData: { dictType: 'incomeMethod' },
      type: 'ajaxSelect',
      placeholder: '请选择收益方式',
    },
    {
      prop: 'isRestrict',
      name: '是否定量',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'isLongRange',
      name: '是否长期合同',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
    },
    {
      prop: 'mark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 512,
    },
  ];
};

export const baseFormRule = (ctx) => {
  return {
    projectInitiationNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    isLongRange: [{ required: true, message: '必填字段', trigger: 'change' }],
    projectName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    supplierNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    departmentCode: [{ required: true, message: '必填字段', trigger: 'blur' }],
    companyCode: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractSalesmanNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractCreateDate: [{ required: true, message: '必填字段', trigger: 'blur' }],
    companyCurrency: [{ required: true, message: '必填字段', trigger: 'blur' }],
    platformCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractOperaterName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    businessType: [{ required: true, message: '必填字段', trigger: 'change' }],
    isFixedPrice: [{ required: true, message: '必填字段', trigger: 'blur' }],
    liquidatedFixedValue: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    isRestrict: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    pricingRule: [
      {
        required: ctx.baseFormData.isFixedPrice && ctx.baseFormData.isFixedPrice == 1,
        message: '必填字段',
        trigger: 'change',
      },
    ], //不定价时必输定价模式
    creditAmount: [
      {
        required: ctx.baseFormData.isPrepay && ctx.baseFormData.isPrepay == 1,
        message: '必填字段',
        trigger: 'blur',
      }, //选择预付后必填
    ],
  };
};
